import React from 'react'
import { useDebounce } from './useDebounce'

export const useStateWithDebounce = (initialState, onDebounce, debounceDelay = 500) => {
  const [state, setState] = React.useState(initialState)
  const [debouncedState, setDebouncedState] = React.useState(initialState)
  useDebounce(
    () => {
      setDebouncedState(state)
      if (onDebounce) {
        onDebounce(state)
      }
    },
    debounceDelay,
    [state]
  )
  const handlers = [state, setState, debouncedState]
  const handlersMemoized = React.useMemo(() => handlers, handlers)
  return handlersMemoized
}
